/**
 * Sanitisation HTML : échappement des caractères dangereux pour innerHTML.
 * À utiliser systématiquement quand on injecte des données utilisateur dans le DOM.
 */
export function escapeHtml(input: unknown): string {
  if (input === null || input === undefined) return '';
  const s = String(input);
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/\//g, '&#x2F;');
}

/** Vérifie qu une chaîne ne contient AUCUN script ou vecteur XSS. */
export function isPotentiallyDangerous(input: string): boolean {
  const dangerous = [
    /<script/i,
    /javascript:/i,
    /on\w+\s*=/i,
    /<iframe/i,
    /<object/i,
    /<embed/i,
    /vbscript:/i,
    /data:text\/html/i,
  ];
  return dangerous.some((r) => r.test(input));
}

/** Force la sanitisation d un nom de compte OHADA (uniquement chiffres). */
export function sanitizeCompteOhada(input: string): string {
  return String(input)
    .replace(/[^0-9]/g, '')
    .slice(0, 8);
}

/** Force la sanitisation d un email. */
export function sanitizeEmail(input: string): string {
  return String(input)
    .toLowerCase()
    .trim()
    .replace(/[<>"']/g, '');
}
